import s from './CodeOfConductPdf.module.css'

export const CodeOfConductPdf = () => {
	return (
		<div className={s.Wrapper}>
			<embed
				src='/conducts.pdf'
				type='application/pdf'
				width='100%'
				height='800px'
			/>
		</div>
	)
}
